import React from 'react';
import { StepFormWrapper } from '../../molecules/form-tab-presenter/form-tabStyles';
import Loading from '../../Lottie/loading';

const LoadingTab = () => {
  return <Loading />;
};

export default LoadingTab;
